'use client';
import AppLayout from '@/components/AppLayout';
import MarketingNav from '@/app/marketing/components/MarketingNav';
import MarketingFooter from '@/app/marketing/components/MarketingFooter';
import { useRoleAuth } from '@/contexts/RoleAuthContext';
import DiamondComparisonContent from './components/DiamondComparisonContent';

/**
 * The diamond comparison tool is a public, SEO-relevant page (it is listed in
 * the sitemap and has a search-optimised title). Signed-out visitors — and
 * therefore crawlers — get the marketing shell with REAL server-rendered
 * content instead of the app shell's auth spinner. Authenticated merchants
 * keep the full app shell (sidebar, inventory shortcuts).
 */
export default function DiamondComparisonPage() {
  const { roleUser, roleLoading } = useRoleAuth();

  if (!roleLoading && roleUser) {
    return (
      <AppLayout>
        <DiamondComparisonContent />
      </AppLayout>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <MarketingNav />
      <main id="main-content">
        <DiamondComparisonContent />
      </main>
      <MarketingFooter />
    </div>
  );
}
